var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenerateArtical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 1C1.76226 1.00008 1.00008 1.76226 1 2.6V63.4C1.00008 64.2377 1.76226 64.9999 2.6 65H66.6C67.4377 64.9999 68.1999 64.2377 68.2 63.4V23.4C68.1999 22.5623 67.4377 21.8001 66.6 21.8H55.4V2.6C55.3999 1.76226 54.6377 1.00008 53.8 1H2.6ZM4.2 4.2H52.2V61.8H4.2V4.2ZM55.4 25H65V61.8H55.4V25ZM12.05 38.6C11.2635 38.6741 10.5966 39.41 10.6 40.2V54.6C10.6001 55.4377 11.3623 56.1999 12.2 56.2H44.2C45.0377 56.1999 45.7999 55.4377 45.8 54.6V40.2C45.7999 39.3623 45.0377 38.6001 44.2 38.6C33.4869 38.6 22.7524 38.6 12.05 38.6ZM13.8 41.8H42.6V53H13.8V41.8Z",
    fill: "#5627D9",
    stroke: "#5627D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 19,
    height: 4,
    rx: 2,
    fill: "#5627D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 34,
    height: 4,
    rx: 2,
    fill: "#5627D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#5627D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateArtical);
export default __webpack_public_path__ + "static/media/generate-artical.b1ff077660c7b35f6c2f3f2e5b27533e.svg";
export { ForwardRef as ReactComponent };